import Button from "@/components/base/Button";
import Seo from "@/components/base/Seo";
import { useUi } from "@/context/UiContext";

export default function NotFound() {
  const { openAi } = useUi();

  return (
    <section className="bg-cream">
      <Seo
        title="頁面未找到｜許文彰｜幸福人才"
        description="這個頁面好像走到別的路上了。你可以回到首頁，或從幸福人才的其他內容重新開始。"
      />
      <div className="mx-auto max-w-container px-4 md:px-6 py-24 md:py-32 lg:py-40">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-7xl md:text-8xl font-black text-primary-dark/10 leading-none select-none">
            404
          </p>
          <h1 className="mt-8 text-2xl md:text-4xl font-bold leading-[1.35] text-ink">
            這個頁面好像走到別的路上了。
          </h1>
          <p className="mt-4 text-base leading-[1.8] text-ink-soft">
            你可以回到首頁，或從幸福人才的其他內容重新開始。
          </p>
          <div className="mt-9 flex flex-col sm:flex-row gap-4 justify-center">
            <Button to="/" icon="ri-home-4-line">
              回到首頁
            </Button>
            <Button onClick={openAi} variant="outline">
              和 AI 幸福人才顧問聊聊
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}